<template>
  <!-- Notice with images -->
  <div @click="noticeEvent('showNotice')">
    <block-title @noticeEvent="noticeEvent" :message="message" />
    <div class="classLabel seeMoreLabel" v-if="message.user_type != 5">
      <span v-if="message.class_label">
        Class:
        <b>{{ message.class_label }}</b>
      </span>
      <span v-if="message.years && !message.class_label">
        Years:
        <b>{{ message.years }}</b>
      </span>
    </div>
    <!-- v-if='message.images.length > 1' -->
    <div class="limitedDiv" v-if="message.message != '<p></p>'">
      <p class="blockText noticeText" v-html="message.message"></p>
    </div>
    <div>
      <span class="seeMoreLabel" style="margin-bottom: 10px">See more</span>
    </div>

    <div
      class="row equal"
      v-if="message.images && message.images.length > 2 && !message.extension"
    >
      <div class="col-xs-7 nopadding" style="margin-left: -3px">
        <div class="bigimg">
          <img :src="message.images[0]" />
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-xs-5 nopadding">
        <div
          class="smallimg"
          style="margin-bottom: 2px"
          :style="{ 'background-image': 'url(' + message.images[1] + ')' }"
        >
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
        <div
          class="smallimg"
          :style="{ 'background-image': 'url(' + message.images[2] + ')' }"
        >
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div
      class="row equal"
      v-if="message.images && message.images.length == 2 && !message.extension"
    >
      <div class="col-xs-6 nopadding" style="margin-left: -3px">
        <div class="bigimg">
          <img :src="message.images[0]" />
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-xs-6 nopadding">
        <div
          class="smallimg"
          style="height: 100%"
          :style="{ 'background-image': 'url(' + message.images[1] + ')' }"
        >
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div
      v-if="message.images && message.images.length == 1 && !message.extension"
    >
      <div class="bigimg oneImage">
        <img :src="message.images[0]" />
        <i class="fa fa-picture-o" aria-hidden="true"></i>
      </div>
    </div>
    <div
      v-if="
        message.images &&
        message.images.length == 2 &&
        message.extension == 'gif'
      "
    >
      <div class="bigimg oneImage">
        <img :src="message.images[1]" />
        <i class="fas fa-circle gifPlayIcon">
          <span>GIF</span>
        </i>
      </div>
    </div>
    <div
      class="videoPoster"
      v-if="
        message.images &&
        message.images.length == 2 &&
        message.extension == 'mp4'
      "
      style="margin: -10px"
    >
      <img
        v-if="message.images[1]"
        :src="message.images[1]"
        style="width: 100%; height: auto; margin-bottom: 15px"
      />
      <i class="fas fa-play-circle videoPlayIcon"></i>
      <!-- <video width="100%" height="auto"  controls="true" preload="metadata" poster="{{ message.images[1] }}" style="max-height: 360px;">
      <source src="{{ message.images[0] }}" type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'>
      Your browser does not support the video tag.
      </video>-->
    </div>
    <!-- <div class="socialLinks" v-if="message.extras.showSocial">
      <div class="row">
        <a
          class="btn btn-link"
          target="_blank"
          href="https://www.instagram.com/homerunapp/?hl=en"
          @click='openUrl($event, "https://www.instagram.com/homerunapp/?hl=en")'
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          class="btn btn-link"
          target="_blank"
          href="https://twitter.com/HomeRunTeam?lang=en"
          @click='openUrl($event, "https://twitter.com/HomeRunTeam?lang=en")'
        >
          <i class="fab fa-twitter"></i>
        </a>
        <a
          class="btn btn-link"
          target="_blank"
          href="https://www.facebook.com/HomeRunSchools/"
          @click='openUrl($event, "https://www.facebook.com/HomeRunSchools/")'
        >
          <i class="fab fa-facebook-f"></i>
        </a>
        <a
          class="btn btn-link"
          target="_blank"
          href="https://www.linkedin.com/company/homerunapp/"
          @click='openUrl($event, "https://www.linkedin.com/company/homerunapp/")'
        >
          <i class="fab fa-linkedin-in"></i>
        </a>
      </div>
    </div>-->
    <div
      class="institution"
      v-if="
        message.user_type != 3 &&
        message.user_type != 5 &&
        message.user_type != 1
      "
    >
      <img src="@/assets/triangle.png" class alt />
      <div class="logo">
        <img
          v-if="message.school_logo"
          :src="
            message.bucket_url +
            '/council/schools/photo/100/' +
            message.school_logo
          "
          alt
        />
      </div>
    </div>
    <NoticeFooter :message="message" @footerEvent="noticeEvent" />
    <div style="clear: both"></div>
  </div>
</template>
<style scoped></style>
<script>
import BlockTitle from "@/components/noticeTypes/other/BlockTitle";
import NoticeFooter from "@/components/noticeTypes/other/NoticeFooter";
export default {
  name: "noticeimages",
  components: {
    BlockTitle,
    NoticeFooter,
  },
  props: {
    message: Object,
  },
  methods: {
    noticeEvent(type) {
      this.$emit("noticeEvent", {
        action: type,
        id: this.message.id,
        user_id: this.message.user_id,
      });
    },
  },
};
</script>
